(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const search = root.querySelector('[data-guide-search]');
    const cards = [...root.querySelectorAll('[data-guide-card]')];
    const filters = [...root.querySelectorAll('[data-guide-category]')];
    const status = root.querySelector('[data-guide-status]');
    const empty = root.querySelector('[data-guide-empty]');
    let category = '';
    const normalize = value => value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    const aliases = { bsod: 'blue screens', ssd: 'storage', nvme: 'storage', disk: 'drive', cmos: 'bios', wifi: 'wi fi', mic: 'microphone', fps: 'fps', gpu: 'graphics', cpu: 'pc', bluetooth: 'bluetooth' };
    function update() {
      const terms = normalize(search.value).split(' ').filter(Boolean);
      let count = 0;
      cards.forEach(card => {
        const haystack = normalize(card.dataset.search);
        const matches = (!category || card.dataset.category === category) && terms.every(term => haystack.includes(term) || (aliases[term] && haystack.includes(aliases[term])));
        card.hidden = !matches;
        if (matches) count++;
      });
      status.textContent = `${count} ${count === 1 ? 'guide' : 'guides'}${category ? ` in ${category}` : ''}`;
      empty.hidden = count !== 0;
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.guideCategory === category)));
    }
    search.addEventListener('input', update);
    filters.forEach(button => button.addEventListener('click', () => { category = button.dataset.guideCategory; update(); }));
    root.querySelector('[data-guide-clear]').addEventListener('click', () => { search.value = ''; update(); search.focus(); });
    root.querySelector('[data-guide-reset]').addEventListener('click', () => { category = ''; search.value = ''; update(); search.focus(); });
    root.querySelector('[data-library-controls]').hidden = false;
    update();
  }
  function boot(scope = document) { scope.querySelectorAll('[data-support-library]').forEach(init); }
  boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
